import jwt_decode from "jwt-decode";

import { clearSessionStorage } from "services/sessionStorage";

// Kept literal rather than imported from services/session to avoid an import cycle.
const EXPIRED_SESSION_URL = "/auth/login?session=expired";

// Fire a little before the refresh token actually dies, so the forced logout is
// ours rather than a wall of 401s.
const MARGIN_MS = 1000;

let timerId = null;

const readExpiry = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    return null;
  }
  try {
    const { exp } = jwt_decode(refreshToken);
    return typeof exp === "number" ? exp : null;
  } catch (e) {
    // A truncated or tampered token is not something we can schedule against.
    return null;
  }
};

export const cancelLogoutWhenTokenExp = () => {
  if (timerId) {
    clearTimeout(timerId);
    timerId = null;
  }
};

/**
 * Schedule the forced logout for the moment the refresh token expires.
 *
 * Call it on login and after every refresh. Earlier this read `exp - iat`, which
 * assumes the token was issued just now: after a refresh mid-session the timer was
 * set to the token's full lifetime instead of its remaining one. It also decoded
 * without checking the token exists, so a missing token threw.
 */
export const logoutWhenTokenExp = () => {
  cancelLogoutWhenTokenExp();

  const exp = readExpiry();
  if (exp === null) {
    return;
  }

  const msUntilExpiry = exp * 1000 - Date.now();
  if (msUntilExpiry <= 0) {
    clearSessionStorage();
    window.location.href = EXPIRED_SESSION_URL;
    return;
  }

  timerId = setTimeout(() => {
    timerId = null;
    const current = readExpiry();
    // A refresh may have happened while we waited; re-arm instead of logging out.
    if (current !== null && current * 1000 > Date.now()) {
      logoutWhenTokenExp();
      return;
    }
    clearSessionStorage();
    window.location.href = EXPIRED_SESSION_URL;
  }, msUntilExpiry + MARGIN_MS);
};
